import { RouteConfig } from 'vue-router';
const BASE_PATH = 'views/dataManagement';
const farmWork: Array<RouteConfig> = [
    {
        path: 'data-manage/farm-work',
        name: 'farmWork',
        redirect: { name: 'farmWorkSettings' },
        meta: {
            menuMatch: 'farmWorkSettings',
        },
        component: () => import(`@/${BASE_PATH}/Main.vue`),
        children: [
            {
                path: 'settings',
                name: 'farmWorkSettings',
                component: () => import(`@/${BASE_PATH}/farmWork/FarmWork.vue`),
                meta: {
                    index: '2',
                },
            },
            {
                path: 'works',
                name: 'farmWorkWorks',
                component: () => import(`@/${BASE_PATH}/farmWork/CoreAuxiliaryWork.vue`),
                meta: {
                    index: '2',
                    noBottom:true
                },
            },
            {
                path: 'operation',
                name: 'farmWorkOperation',
                component: () => import(`@/${BASE_PATH}/farmWork/OperationGuide.vue`),
                meta: {
                    index: '2',
                },
            },
            {
                path: 'registration',
                name: 'farmWorkRegistration',
                component: () => import(`@/${BASE_PATH}/farmWork/WorkRegistration.vue`),
                meta: {
                    index: '2',
                },
            },
            {
                path: 'template',
                name: 'farmWorkTemplate',
                component: () => import(`@/${BASE_PATH}/farmWork/WorkRegistrationTemplate.vue`),
                meta: {
                    index: '2',
                },
            },
            {
                path: 'add-template',
                name: 'farmWorkAddTemplate',
                component: () => import(`@/${BASE_PATH}/farmWork/AddTemplate.vue`),
                meta: {
                    index: '2',
                },
            },
        ],
    },
];
export default farmWork;